





























import { defineComponent, ref, computed } from '@vue/composition-api';
import type { PropType, ComputedRef } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Field } from '../types/field';
import { FieldSource } from '../types/enums/field-source';
import { defaultDropdownOption } from '../constants/field-placeholders';

export default defineComponent({
  name: 'DropdownField',
  props: {
    field: { type: Object as PropType<Field>, required: true },
    disabled: { type: Boolean, required: true },
    completed: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const dropdownOpen = ref(false);

    const value = computed(() => {
      if (props.field.source === FieldSource.Sender) {
        return props.field.value || props.field.label;
      }
      return props.field.value || props.field.label || defaultOption.value;
    });

    const showRequired: ComputedRef<boolean> = computed(() => {
      if (props.completed || props.disabled) {
        return false;
      }
      return props.field.isRequired;
    });

    const options: ComputedRef<string[]> = computed(() => {
      if (isDefaultValue(value.value as string) || props.field.isRequired) {
        return props.field.options;
      }
      return [defaultOption.value, ...props.field.options];
    });

    const defaultOption: ComputedRef<string> = computed(() => t(defaultDropdownOption).toString());

    const isDefaultValue = (value: string) => value === defaultOption.value;

    const handleSelection = (value: string) => {
      if (!props.disabled) {
        emit('update', value);
        closeDropdown();
      }
    };

    const toggleDropdown = () => {
      if (props.disabled) {
        return;
      }
      dropdownOpen.value = !dropdownOpen.value;
      emit('toggleDropdown', dropdownOpen.value);
    };

    const closeDropdown = () => {
      dropdownOpen.value = false;
      emit('toggleDropdown', dropdownOpen.value);
    };

    return {
      dropdownOpen,
      value,
      showRequired,
      options,
      defaultOption,
      isDefaultValue,
      handleSelection,
      toggleDropdown,
      closeDropdown,
    };
  },
});
